/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4641f9e6"]'><div><cube-button @_click="showPickerWithSetTime">Use setTime</cube-button><cube-time-picker ref="__mpx_ref_picker__"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_4641f9e6"}'>
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4641f9e6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4641f9e6"}
  /** script content **/
  require("./set-time-picker.mpx.js?isComponent&outputPath=components%2Fset-time-picker4641f9e6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./set-time-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fset-time-picker4641f9e6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4641f9e6"],
    ctorType: "component",
    outputPath: "components/set-time-picker4641f9e6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>